;(function () {
  angular.module('contrast.filters').filter('numAbsolute', function () {
    return function (num) {
      return Math.abs(num)
    }
  })
})()
